export const formatDate = dateString => {
  try {
    return new Date(dateString).toLocaleString('sv-SE');
  } catch (err) {
    return dateString;
  }
};
